"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionAvatar = exports.subscriptionAvatarTestIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const Avatar_1 = require("./Avatar");
exports.subscriptionAvatarTestIds = {
    avatar: 'subscription-avatar',
    closeIcon: 'subscription-close-icon',
};
const trackingIds = {
    closeBtn: 'subscription_avatar-close_btn',
};
const getStyles = (theme) => ({
    root: {
        position: 'relative',
        '&:hover button': {
            display: 'block',
        },
    },
    close: {
        position: 'absolute',
        cursor: 'pointer',
        top: '-8px',
        zIndex: 9999,
        display: 'none',
    },
    closeIcon: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.action.active,
        borderRadius: '50%',
        padding: theme.spacing(0.25),
    },
    nameContainer: {
        display: 'inline-block',
        width: 60,
        textAlign: 'center',
        marginTop: theme.spacing(0.6),
    },
    name: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
});
const SubscriptionAvatar = (props) => {
    const { avatar, avatarType, disabled, hoverText, subscriberName, displayName, className, onClick, avatarUserType } = props;
    const [firstName, lastName] = subscriberName ? subscriberName.split(' ') : ['', ''];
    const styles = getStyles((0, silhouette_core_1.useTheme)());
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Tooltip, { title: hoverText || '', children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { "data-testid": exports.subscriptionAvatarTestIds.avatar, sx: styles['root'], className: className, display: "flex", flexDirection: "column", alignItems: "center", width: displayName ? 60 : 44, children: [!disabled && ((0, jsx_runtime_1.jsx)(silhouette_core_1.IconButton, { "data-tracking-id": trackingIds.closeBtn, "data-testid": exports.subscriptionAvatarTestIds.closeIcon, onClick: onClick, sx: { ...styles['close'], right: displayName ? '-2px' : '-8px' }, size: "small", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CloseIcon, { sx: styles['closeIcon'], fontSize: "small" }) })), (0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { avatar: avatar, avatarType: avatarType, userType: avatarUserType, size: "large", fullName: subscriberName }), displayName && ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { sx: styles['nameContainer'], children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body3", sx: styles['name'], component: "p", children: firstName }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body3", sx: styles['name'], component: "p", children: lastName })] }))] }) }));
};
exports.SubscriptionAvatar = SubscriptionAvatar;
//# sourceMappingURL=SubscriptionAvatar.js.map